import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { ChildAuthService } from '../services/child-auth.service';
import { ChildLoginService } from '../services/child-login.service';

@Injectable({
  providedIn: 'root'
})
export class ChildAuthGuard implements CanActivate {
  constructor(
    private childAuth: ChildAuthService,
    private childLogin: ChildLoginService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    console.log('[ChildAuthGuard] Checking access for route:', route.url.join('/'));
    console.log('[ChildAuthGuard] Child mode active:', this.childAuth.isChildMode());
    console.log('[ChildAuthGuard] Child logged in:', this.childAuth.isChildLoggedIn());
    
    if (this.childAuth.isChildMode() && !this.childAuth.isChildLoggedIn()) {
      console.log('[ChildAuthGuard] Blocking route access, showing login modal');
      this.childLogin.showLoginRequiredModal();
      return false;
    }
    
    console.log('[ChildAuthGuard] Allowing route access');
    return true;
  }
} 